export default __webpack_public_path__ + "static/media/The Graphic Social.47469854.pdf";